






import { formatSocialIcon } from '../../../utils/formatter'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SocialIcon extends Vue {
  @Prop({ required: true, type: String, default: '' }) readonly social!: string
  @Prop({ type: Boolean, default: false }) readonly defaultColor?: boolean

  get socialIcon(): string {
    return formatSocialIcon(this.social)
  }
  get socialClass(): string {
    return this.social
  }
}
